import { EmojisValues } from "./Emojis";

export const emojisStyles = {
  emoji: {
    fontSize: 14,
    boxShadow: "0px 2px 5px 0px rgba(198, 179, 211, 0.5)",
    borderRadius: "50%"
  },
  container: {
    display: "flex"
  },
  title: {
    fontSize: 12,
    marginTop: 8
  }
} 

export const emojiContainerStyle = (selectedRating: EmojisValues, rating: EmojisValues) => {
  const baseStyle: any = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0 12px",
    cursor: "pointer"
  }

  if (selectedRating && selectedRating !== rating) {
    baseStyle.opacity = 0.3;
  }

  return baseStyle;
}